export const projectsList = {
  label: 'Назва проектів',
  price: 'Ціна проекту: 3.400 €',
  execution: 'Виконання бюджету: 324.166 €',
};
